var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { I18NLink } from "../../I18N";
import SearchDescription from "../../Library/components/SearchDescription";
import { withContext } from "../../componentWrappers";
import { Icon, ProgressBar } from "../../UI";

import { deleteSearch, resumeSearch, stopSearch } from "../actions/actions";

class SearchItemComponent extends Component {
  constructor(props) {
    super(props);
    this.delete = this.delete.bind(this);
    this.handleResumeClicked = this.handleResumeClicked.bind(this);
    this.handleStopClicked = this.handleStopClicked.bind(this);
  }

  handleStopClicked(e) {
    const { search, onStopClicked } = this.props;
    onStopClicked(search._id);
    e.preventDefault();
  }

  handleResumeClicked(e) {
    const { search, onResumeClicked } = this.props;
    onResumeClicked(search._id);
    e.preventDefault();
  }

  delete(e) {
    const { onDeleteClicked, search } = this.props;
    e.preventDefault();
    this.props.mainContext.confirm({
      accept: onDeleteClicked.bind(this, search._id),
      title: 'Confirm delete',
      message: 'Are you sure you want to delete this search?'
    });
  }

  renderButtons() {
    const { search } = this.props;
    const { status } = search;
    return /*#__PURE__*/(
      _jsx("div", { className: "buttons" }, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", className: "btn btn-danger delete-search btn-xs", onClick: this.delete }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "trash-alt", size: "sm" })
      ),
      ['inProgress', 'pending'].includes(status) && /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-warning stop-search btn-xs",
        onClick: this.handleStopClicked }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "stop", size: "sm" })
      ),

      status === 'stopped' && /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-success resume-search btn-xs",
        onClick: this.handleResumeClicked }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "play", size: "sm" })
      )

      ));

  }

  render() {
    const { search } = this.props;
    const { status, documents } = search;
    const completed = documents.filter((doc) => doc.status === 'completed').length;
    const max = documents.length;
    return /*#__PURE__*/(
      _jsx(I18NLink, { className: "semantic-search-list-item", to: `semanticsearch/${search._id}` }, void 0, /*#__PURE__*/
      _jsx("div", { className: "item-header" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "title" }, void 0, /*#__PURE__*/
      _jsx(SearchDescription, { searchTerm: search.searchTerm, query: search.query })
      ),
      this.renderButtons()
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, status !== 'completed' && /*#__PURE__*/_jsx(ProgressBar, { value: completed, max: max }))
      ));

  }
}

















function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onDeleteClicked: deleteSearch,
      onStopClicked: stopSearch,
      onResumeClicked: resumeSearch
    },
    dispatch
  );
}

const SearchItem = connect(null, mapDispatchToProps)(withContext(SearchItemComponent));
export { SearchItemComponent, mapDispatchToProps, SearchItem };